module.exports = require("./mzn.d.ts");